<div class="component-content paged heightcls">
    <table class="table m-table table-bordered table-hover table-heading">
        <colgroup>
            <col style="width: 35%">
            <col style="width: 15%">
            <col style="width: 10%">
            <col style="width: 30%">
            <col style="width: 10%">
        </colgroup>
        <thead>
            <tr>
                <th>
                    <span>User Name</span>
                    <button class="btn btn-default btn-xs pull-right" (click)="sortBy('UserName')" [class.btn-warning]="isSort('UserName')" [class.btn-default]="!isSort('UserName')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="ascending" [class.fa-sort-alpha-desc]="!ascending"></i>
                    </button>
                </th>
                <th>
                    <span>Skeleton Key</span>
                </th>
                <th>
                    <span>Last Seen</span>
                    <button class="btn btn-default btn-xs pull-right" (click)="sortBy('LastSeen')" [class.btn-warning]="isSort('LastSeen')" [class.btn-default]="!isSort('LastSeen')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="ascending" [class.fa-sort-alpha-desc]="!ascending"></i>
                    </button>
                </th>
                <th>
                    <span>Device Id</span>
                    <button class="btn btn-default btn-xs pull-right" (click)="sortBy('DeviceId')" [class.btn-warning]="isSort('DeviceId')" [class.btn-default]="!isSort('DeviceId')">
                        <i class="fa fa-lg" [class.fa-sort-alpha-asc]="ascending" [class.fa-sort-alpha-desc]="!ascending"></i>
                    </button>
                </th>
                <th>
                    <span>&nbsp;</span>
                    <div class="btn-group btn-group-md">
                        <!--<device-filter></device-filter>-->
                        <device-filter (isProcessing)="updateProcessing($event)"></device-filter>
                    </div>
                </th>
            </tr>
        </thead>
    </table>

    <table class="table m-table table-bordered table-hover" style="height:95%; overflow-y:scroll; display:block;">
        <colgroup>
            <col style="width: 35%">
            <col style="width: 15%">
            <col style="width: 10%">
            <col style="width: 30%">
            <col style="width: 9%">
        </colgroup>
        <tr *ngIf="processing">
            <td colspan="5" style="align-content:center">
                <div style="text-align:center;">
                    <h3>Loading Devices...</h3>
                    <i class="fa fa-spinner fa-spin fa-pulse fa-5x"></i>
                </div>
            </td>
        </tr>
        <tr *ngFor="let device of devices.Data">
            <td class="table-bordered" style="padding: 4px;">
                <div>{{ device.User.UserName }}</div>
            </td>
            <td class="table-bordered" style="padding: 4px;">
                <div class="btn-group btn-group-justified">
                    <a class="btn btn-sm btn-default" (click)="showSkeletonKey(device)">View Skeleton Key</a>
                </div>
            </td>
            <td class="table-bordered" style="padding: 4px;">
                <div *ngIf="device.LastSeen" class="form-control-static">{{ device.LastSeen | amDateFormat: 'MM/DD/YYYY' }} at {{ device.LastSeen | amDateFormat: 'hh:mm A' }}</div>
            </td>
            <td class="table-bordered" style="padding: 4px;">
                <div *ngIf="device.IosDevice.iOSDeviceId"> {{  '(iOS) ' + device.IosDevice.iOSDeviceId  }}</div>
                <div *ngIf="device.DeviceId"> {{  '(Windows) ' + device.DeviceId  }}</div>
                <div *ngIf="device.AndroidDeviceId"> {{  '(Android) ' + device.AndroidDeviceId  }}</div>
            </td>
            <td class="table-bordered" style="padding: 4px;">
                <div class="btn-group btn-group-justified">
                    <a class="btn btn-primary btn-sm" title="View Details" (click)="showDetails(device)">
                        <i class="fa fa-fw fa-lg fa-list-alt" data-toggle="tooltip"></i>
                    </a>
                </div>
            </td>
        </tr>
    </table>
</div>


<div bsModal #skeletonKey="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" data-bind="with: entity">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="closeSkeletonKey()" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title" id="myModalLabel">
                    Skeleton Key for {{ device.User.UserName }}

                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="input-group">
                            <label class="input-group-addon">Device Id</label>
                            <input *ngIf="device.IosDevice.iOSDeviceId" type="text" class="form-control" value="(iOS) {{ device.IosDevice.iOSDeviceId }}" disabled />
                            <input *ngIf="device.DeviceId" type="text" class="form-control" value="(Windows) {{ device.DeviceId }}" disabled />
                            <input *ngIf="device.AndroidDeviceId" type="text" class="form-control" value="(Android) {{ device.AndroidDeviceId }}" disabled />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="input-group">
                            <label class="input-group-addon">Skeleton Key</label>
                            <input type="text" class="form-control" value="{{ device.SkeletonKey }}" disabled />
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="closeSkeletonKey()">Close</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #deviceDetails="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width: 900px;">
        <div class="modal-content" data-bind="with: entity">
            <div class="modal-header">
                <button type="button" class="close" (click)="closeDetails()" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title" id="myModalLabel">
                    Device Details &bull; {{ device.User.UserName }}
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="input-group">
                            <label class="input-group-addon">Device Id</label>
                            <input *ngIf="device.IosDevice.iOSDeviceId" type="text" class="form-control" value="(iOS) {{ device.IosDevice.iOSDeviceId }}" disabled />
                            <input *ngIf="device.DeviceId" type="text" class="form-control" value="(Windows) {{ device.DeviceId }}" disabled />
                            <input *ngIf="device.AndroidDeviceId" type="text" class="form-control" value="(Android) {{ device.AndroidDeviceId }}" disabled />
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-lg-12" style="height: 380px;">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <h4>Documents on Device</h4>
                            </div>
                            <div class="panel-body" style="height: 320px; overflow-y: scroll;">
                                <table class="table table-bordered" style="width:100%;">
                                    <thead>
                                        <tr>
                                            <th>Document Name</th>
                                            <th>Version</th>
                                            <th>Downloaded</th>
                                            <th>Last Updated</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let document of documents">
                                            <td>
                                                <span class="text-success fa fa-check-circle" *ngIf="document.Document.Publishing"></span>
                                                <span class="text-danger fa fa-warning" *ngIf="!document.Document.Publishing"></span>
                                                {{ document.Document.ProductName }}
                                                <br />
                                                {{ document.Document.FileName }}
                                            </td>
                                            <td>
                                                {{ document.Document.Version }}
                                            </td>
                                            <td>
                                                {{ document.DownloadDate | amDateFormat: 'MM/DD/YYYY' }} at {{ document.DownloadDate | amDateFormat: 'hh:mm A' }}
                                            </td>
                                            <td>
                                                {{ document.Document.Updated | amDateFormat: 'MM/DD/YYYY' }} at {{ document.Document.Updated | amDateFormat: 'hh:mm A' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="closeDetails()">Close</button>
            </div>
        </div>
    </div>
</div>